export enum InvoicesOlsaActionType {
  FETCH_INVOICES_OLSA = 'FETCH_INVOICES_OLSA',
  FETCH_SELECTED_INVOICE_OLSA = 'FETCH_SELECTED_INVOICE_OLSA'
}
